import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, AlertCircle, Clock, CheckCircle2, FileText, Upload } from 'lucide-react';
export function DepositsSettlementsPage() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-7xl mx-auto" data-id="element-3087">
      <div className="mb-8" data-id="element-3088">
        <h2 className="text-2xl font-bold mb-1" data-id="element-3089">Deposits & Settlements</h2>
        <p className="text-sm text-textMuted" data-id="element-3090">
          Track expected, committed, and collected money across shows.
        </p>
      </div>

      {/* Overview Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-3091">
        <div className="bg-surface border border-border rounded-xl p-5" data-id="element-3092">
          <div className="flex items-center justify-between mb-2" data-id="element-3093">
            <div className="w-10 h-10 rounded-lg bg-blue-500/10 flex items-center justify-center text-blue-500" data-id="element-3094">
              <Clock className="w-5 h-5" data-id="element-3095" />
            </div>
          </div>
          <p className="text-sm text-textMuted mb-1" data-id="element-3096">Deposits Due This Week</p>
          <h4 className="text-2xl font-bold" data-id="element-3097">$3,500</h4>
        </div>
        <div className="bg-surface border border-border rounded-xl p-5" data-id="element-3098">
          <div className="flex items-center justify-between mb-2" data-id="element-3099">
            <div className="w-10 h-10 rounded-lg bg-red-500/10 flex items-center justify-center text-red-500" data-id="element-3100">
              <AlertCircle className="w-5 h-5" data-id="element-3101" />
            </div>
          </div>
          <p className="text-sm text-textMuted mb-1" data-id="element-3102">Overdue Deposits</p>
          <h4 className="text-2xl font-bold text-red-500" data-id="element-3103">$1,200</h4>
        </div>
        <div className="bg-surface border border-border rounded-xl p-5" data-id="element-3104">
          <div className="flex items-center justify-between mb-2" data-id="element-3105">
            <div className="w-10 h-10 rounded-lg bg-amber-500/10 flex items-center justify-center text-amber-500" data-id="element-3106">
              <DollarSign className="w-5 h-5" data-id="element-3107" />
            </div>
          </div>
          <p className="text-sm text-textMuted mb-1" data-id="element-3108">Unsettled Shows</p>
          <h4 className="text-2xl font-bold" data-id="element-3109">3</h4>
        </div>
        <div className="bg-surface border border-border rounded-xl p-5" data-id="element-3110">
          <div className="flex items-center justify-between mb-2" data-id="element-3111">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary" data-id="element-3112">
              <CheckCircle2 className="w-5 h-5" data-id="element-3113" />
            </div>
          </div>
          <p className="text-sm text-textMuted mb-1" data-id="element-3114">Pending Confirmations</p>
          <h4 className="text-2xl font-bold" data-id="element-3115">2</h4>
        </div>
      </div>

      {/* Deposits Section */}
      <div className="mb-12" data-id="element-3116">
        <h3 className="text-lg font-semibold mb-4" data-id="element-3117">Deposits Queue</h3>
        <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-3118">
          <table className="w-full text-sm text-left" data-id="element-3119">
            <thead className="text-xs text-textMuted uppercase bg-background/50 border-b border-border" data-id="element-3120">
              <tr data-id="element-3121">
                <th className="px-6 py-4 font-medium" data-id="element-3122">Show / Deal</th>
                <th className="px-6 py-4 font-medium" data-id="element-3123">Due Date</th>
                <th className="px-6 py-4 font-medium" data-id="element-3124">Amount</th>
                <th className="px-6 py-4 font-medium" data-id="element-3125">Stage</th>
                <th className="px-6 py-4 font-medium" data-id="element-3126">Proof</th>
                <th className="px-6 py-4 font-medium" data-id="element-3127">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border" data-id="element-3128">
              {[{
              show: 'The Empty Bottle',
              date: 'Jun 01',
              amount: '$750.00',
              stage: 'Requested',
              proof: 'None',
              status: 'Pending'
            }, {
              show: 'Beachland Tavern',
              date: 'May 28',
              amount: '$600.00',
              stage: 'Paid Off-Platform',
              proof: 'receipt.pdf',
              status: 'Needs Approval'
            }, {
              show: 'Higher Ground',
              date: 'May 15',
              amount: '$1,000.00',
              stage: 'Overdue',
              proof: 'None',
              status: 'Overdue'
            }].map((deposit, i) => <tr key={i} className="hover:bg-surfaceHover/50 transition-colors" data-id="element-3129">
                  <td className="px-6 py-4 font-medium" data-id="element-3130">{deposit.show}</td>
                  <td className="px-6 py-4" data-id="element-3131">{deposit.date}</td>
                  <td className="px-6 py-4 font-medium" data-id="element-3132">{deposit.amount}</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-3133">{deposit.stage}</td>
                  <td className="px-6 py-4" data-id="element-3134">
                    {deposit.proof !== 'None' ? <a href="#" className="text-primary hover:underline flex items-center gap-1 text-xs" data-id="element-3135">
                        <FileText className="w-3 h-3" data-id="element-3136" /> {deposit.proof}
                      </a> : <button className="text-xs text-textMuted hover:text-textMain flex items-center gap-1" data-id="element-3137">
                        <Upload className="w-3 h-3" data-id="element-3138" /> Upload
                      </button>}
                  </td>
                  <td className="px-6 py-4" data-id="element-3139">
                    <span className={`px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider ${deposit.status === 'Needs Approval' ? 'bg-primary/10 text-primary' : deposit.status === 'Overdue' ? 'bg-red-500/10 text-red-500' : 'bg-surfaceHover text-textMuted'}`} data-id="element-3140">
                      {deposit.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* Settlements Section */}
      <div data-id="element-3141">
        <h3 className="text-lg font-semibold mb-4" data-id="element-3142">Recent Settlements</h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-3143">
          <div className="bg-surface border border-border rounded-xl p-6" data-id="element-3144">
            <div className="flex justify-between items-start mb-6" data-id="element-3145">
              <div data-id="element-3146">
                <h4 className="font-bold text-lg" data-id="element-3147">The Sinclair</h4>
                <p className="text-sm text-textMuted" data-id="element-3148">May 20, 2026</p>
              </div>
              <span className="px-2 py-1 bg-green-500/10 text-green-500 text-xs font-bold uppercase tracking-wider rounded" data-id="element-3149">
                Settled
              </span>
            </div>
            <div className="space-y-3 mb-6" data-id="element-3150">
              <div className="flex justify-between text-sm" data-id="element-3151">
                <span className="text-textMuted" data-id="element-3152">Gross Ticket Sales</span>
                <span data-id="element-3153">$3,200.00</span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-3154">
                <span className="text-textMuted" data-id="element-3155">Guarantee</span>
                <span data-id="element-3156">$2,500.00</span>
              </div>
              <div className="flex justify-between text-sm text-red-500" data-id="element-3157">
                <span data-id="element-3158">Expenses (Sound/Lights)</span>
                <span data-id="element-3159">-$150.00</span>
              </div>
              <div className="flex justify-between text-sm text-red-500" data-id="element-3160">
                <span data-id="element-3161">Withholdings (Tax)</span>
                <span data-id="element-3162">-$0.00</span>
              </div>
              <div className="pt-3 border-t border-border flex justify-between font-bold" data-id="element-3163">
                <span data-id="element-3164">Total Collected</span>
                <span className="text-green-500" data-id="element-3165">$2,350.00</span>
              </div>
            </div>
            <button className="w-full py-2 bg-primary/10 text-primary rounded-lg text-sm font-medium hover:bg-primary/20 transition-colors" data-id="element-3166">
              Process Member Payouts
            </button>
          </div>
        </div>
      </div>
    </motion.div>;
}